(function () { 
 return angular.module("environment.config", [])
.constant("ENV_CONFIG", {"baseURI":"http://localhost:9000","baseAPI":"http://localhost:9000/api/"});

})();
